export default {

    state: {
        editor: {
            toolbar: [
            [   { header: [false, 2, 3, 4] }],
                ["bold", "italic", "underline"],
                [{ list: "bullet" }, { list: "ordered" }],
                ["link"]
            ],
        },

        datePickerOptions: {
            format: 'MMM D, YYYY',
            ignoreReadonly: true,
        },

        layout: 'desktop',

        loaded: {
            groups: false,
            physicians: false,
            routes: false,
            campaigns: false,
            accounts: false,
            options: false,
        }
    },

    mutations: {
        setLayout(state, layout) {
            state.layout = layout;
        }
    }
};